import React, { Component } from 'react'
import './Clientes.css'; 
import NuevoCliente from './NuevoCliente'; 
import ListaClientes from './ListaClientes'; 

export class Clientes extends Component {
   
    

    render() {
       
   
        return (
            <div className="clientes_container">
                <div className="titulo_section">
                <div className="titulo_clientes">
                <h1 className="text-clientes"> Mis Prestadores</h1>
                <hr className="clientes_separator"></hr>            
                
                </div>

                <div className="div_boton">
                <NuevoCliente/>
                </div>
               
                </div>
                
                

                <div className="listaclientes_container">
                <ListaClientes/>
                </div>

               
                </div>
                
           
               
               
               
            
               
                
               
                
           
        )
    }
}

export default Clientes
